module.exports = __webpack_public_path__ + "img/古灵.d0841967.png";